export default __webpack_public_path__ + "static/media/logo-dark-strive.4860dbda.svg";